// utils/fees.js
// No client-side fees. Every price (face, fee, total, Pi amount) comes from the backend
// (computePlatformFee, 15%): vouchers/topups/eSIMs via the checkout intent, Pi via the
// server quote. If a price is unavailable the UI shows nothing / disables checkout.

// Promos disabled
export function getActivePromo(_subTypes = [], _countryCode = "", _tz = "Europe/Madrid") {
  return null;
}
